import {
  StockOutOrderMaterialServiceProxy,
  StockOutOrderServiceProxy
} from '@/service-proxies/app-v2/wms.service-proxies'
import { CodeRuleServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'
import { SupplierServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'

const soosp = new StockOutOrderServiceProxy()
const ssp = new SupplierServiceProxy()
const crsp = new CodeRuleServiceProxy()
const soomsp = new StockOutOrderMaterialServiceProxy()

export default {
  data() {
    return {
      deliveryUserName: '',
      receivingDeptName: '',
      receivingUserName: '',
      supplierName: '',
      codeRule: undefined,
      comformDefa: {
        isPlan: false,
        selectPlan: '',
        planList: [],
        canAddTwo: false,
        hasOutOrder: false,
        hasStockOutPlan: false,
        isPlanAdd: true
      }
    }
  },
  props: {
    staff: {
      type: Array,
      default: () => []
    },
    depts: {
      type: Array,
      default: () => []
    },
    inTypeCode: {
      type: String,
      default: ''
    }
  },
  watch: {
    inTypeCode: {
      handler() {
        this.comformDefa = {
          isPlan: false,
          selectPlan: '',
          planList: [],
          canAddTwo: false,
          hasOutOrder: false,
          hasStockOutPlan: false,
          isPlanAdd: true
        }
        this.$emit('changDefa', this.comformDefa)
      }
    }
  },
  async created() {
    this.getList()
    this.getSupplierList()
    this.getStockOutOrder()
    this.comformDefa = {
      isPlan: false,
      selectPlan: '',
      planList: [],
      canAddTwo: false,
      hasOutOrder: false,
      hasStockOutPlan: false,
      isPlanAdd: true
    }
    this.$emit('changDefa', this.comformDefa)
  },
  methods: {
    changeReast() {
      this.comformDefa = {
        isPlan: false,
        selectPlan: '',
        planList: [],
        canAddTwo: false,
        hasOutOrder: false,
        hasStockOutPlan: false,
        isPlanAdd: true
      }
    },
    selectCodeRule(value) {
      this.form.setFieldsValue({
        orderCode: ''
      })
      this.codeRule = value
    },
    addCode(value) {
      const data = []
      if (value && value.length > 0) {
        value.forEach((element) => {
          element.code = element.planCode
          element.id = element.planId
          data.push(element)
        })
      }
      return data
    },
    getSupplierList() {
      ssp.getPageSupplier(1, '', 999999).then((res) => {
        this.supplierList = res.records
      })
    },
    getStockOutOrder() {
      this.stockOutOrderList = []
      const wmsRouters = this.$store.getters.wmsRoutes
      const areaId = (this.$route.query.materialId
        ? this.$route.query.materialId
        : wmsRouters && wmsRouters[0] && wmsRouters[0].id
      ).toString()
      soosp.pageStockOutOrder(areaId, 1, '', 999999).then((res) => {
        this.stockOutOrderList = res.records
      })
    },
    async getList() {
      let result = await crsp.list('StockInObject')
      this.codeList = result.map((item) => ({ label: item.name, value: item.id }))
    },
    handleSelectChange(val) {
      let person = this.staff.find((items) => items.id === val)
      if (person && person.hasOwnProperty('name')) this.deliveryUserName = person.name
    },
    handleReceivingDeptName(val) {
      this.value = val
      this.depts.find((item) => {
        this.forName(item)
      })
    },
    forName(item) {
      if (item.value === this.value) this.receivingDeptName = item.title
      if (item && item.hasOwnProperty('children'))
        if (item.children.length > 0)
          item.children.find((items) => {
            this.forName(items)
          })
    },
    handleReceivingUser(val) {
      let person = this.staff.find((items) => items.id === val)
      if (person && person.hasOwnProperty('name')) this.receivingUserName = person.name
    },
    handleSupplierName(val) {
      let name = this.supplierList.find((items) => items.id === val)
      if (name && name.hasOwnProperty('name')) this.supplierName = name.name
    },
    handleChangeOutOrder(value) {
      if (value === undefined) {
        this.comformDefa.canAdd = true
        this.comformDefa.hasOutOrder = false
        this.$emit('chengeMaterial', [])
        return
      }
      this.comformDefa.hasOutOrder = true
      if (this.comformDefa.isPlan) {
        this.comformDefa.isPlanAdd = false
        this.comformDefa.canAdd = false
      } else {
        this.comformDefa.isPlanAdd = false
        this.comformDefa.canAdd = false
      }
      this.loading = true
      this.$emit('changDefa', this.comformDefa)
      soomsp.getStockOutOrderMaterialByCode(value).then((res) => {
        const dataSource = this.addOrderKey(res)
        console.log(dataSource, 665)
        this.$emit('chengeMaterial', dataSource)
        this.loading = false
      })
    },
    addOrderKey(data) {
      const value = []
      if (data && data.length > 0) {
        data.forEach((res, index) => {
          const values = {
            key: index,
            id: res.id,
            materialId: res.id,
            barCode: res.barCode,
            materialTypeName: res.typeName,
            materialCode: res.materialCode,
            materialName: res.materialName,
            batchCode: '',
            isMustCheck: res.isMustCheck,
            materialStandardModel: res.standardModel,
            materialStuff: res.stuff,
            materialUnit: res.unit,
            number: 0,
            totalNum: 0,
            stockInNum: 0,
            price: '',
            remark: '',
            stockOutNum: res.stockOutNum,
            areaId: res.areaId,
            areaName: res.areaName,
            locationId: res.locationId,
            locationName: res.locationName,
            testResult: null,
            contentType: '',
            supplierId: '',
            fileName: '',
            fileObjectKey: ''
          }
          value.push(values)
        })
      }
      return value
    }
  }
}
